export default __webpack_public_path__ + "static/media/pm.f5021bcc.png";